const map = {
	"./AIP.svg": 3619,
	"./Ontology.svg": 2976,
	"./PLTR.D.svg": 5299,
	"./PLTR_BIG.svg": 1966,
	"./Palantir.png": 4868,
	"./address_image.svg": 8415,
	"./animated_aditya.png": 8843,
	"./blockchain.svg": 3273,
	"./blogs_image.svg": 1108,
	"./cloud_infrastructure.svg": 5820,
	"./codeInLogo.png": 9384,
	"./contactMail.png": 3914,
	"./coursera_logo.png": 8857,
	"./data-pipeline.svg": 1094,
	"./data_science.svg": 8712,
	"./deeplearning_ai_logo.png": 774,
	"./delhivery_logo.png": 7311,
	"./developerActivity.svg": 9504,
	"./devicon--replit.svg": 89,
	"./dsc_logo.png": 3979,
	"./education.svg": 1803,
	"./experience.svg": 1071,
	"./feelingProud.svg": 2677,
	"./folder.svg": 7299,
	"./freecopy_logo.png": 1434,
	"./fullstack.svg": 1272,
	"./gcp_logo.png": 4375,
	"./github_logo.png": 9214,
	"./googleAssistant.jpg": 3440,
	"./googleAssistant.svg": 9650,
	"./google_logo.png": 6038,
	"./ibm_logo.png": 5539,
	"./iiitk_logo.png": 2837,
	"./image.svg": 6794,
	"./intel_logo.jpg": 1021,
	"./iu_logo.png": 8291,
	"./jsFramework.svg": 4406,
	"./layer5-dark-bg.svg": 9284,
	"./legato_logo.png": 7147,
	"./manOnTable.svg": 3350,
	"./meshery-logo-dark-text-side.svg": 8943,
	"./microsoft_logo.png": 3953,
	"./mozilla_logo.png": 9105,
	"./msu_logo.svg": 3206,
	"./muffito_logo.png": 3981,
	"./nextuLogo.jpg": 8846,
	"./nptel_logo.png": 3862,
	"./openai_logo.svg": 7093,
	"./passprt.jpeg": 3049,
	"./polaris.jpeg": 9680,
	"./portfolio.gif": 7888,
	"./programmer.svg": 2075,
	"./projects_image.svg": 5739,
	"./pst_logo.png": 542,
	"./pwa.png": 7399,
	"./saayaHealthLogo.png": 4123,
	"./sign.svg": 8040,
	"./sobd.svg": 3567,
	"./stanford_logo.png": 4216,
	"./talking_on_phone.svg": 2916,
	"./talksCardBack.svg": 7175,
	"./talksCardBackAlt.svg": 6740,
	"./tiktok_logo.png": 7427,
	"./ui_ux_design.svg": 7880,
	"./working.svg": 3476
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;